<ng-container *ngIf="event$ | async as event">
  <div class="info">
    <h3>
      <pr-formatted-event-field
        field="from"
        [event]="event"
        [format]="dateFormat"
      />
    </h3>
    <p>{{ timeDisplay$ | async }}</p>
  </div>

  <div class="info">
    <h3>{{ event.practice.name }}</h3>
  </div>
</ng-container>

<div class="info">
  <h3>Participants</h3>

  <div
    *ngFor="
      let participant of participants$ | async;
      trackBy: trackByParticipant
    "
    class="participant flex items-center gap-4"
  >
    <pt-user-icon
      [diameter]="36"
      [src]="participant | profileImage$ | async"
      [name]="participant.name"
    />

    <pr-event-participant-link [participant]="participant">
      {{ participant.name }}
    </pr-event-participant-link>
  </div>
</div>
